module.exports = __webpack_public_path__ + "media/fonts/Lato-SemiBold-f5682057ffec91c648ac10d8ccc82274.woff2";